import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import Opinie_wyb from './Opinie_wyb';
import NavBar from './NavBar';
import Zak_opiniowanie from './Zak_opiniowanie';
import Popup from "reactjs-popup";


export default class Opinie extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    nazwastrony: 'Opinie',
    dataopinie1: [],
    dataopinie2: [],
    rok: props.rok,
    indexwyb: props.indexwyb,
    DWBP: props.DWBP,
    idWydzialu: props.idWydzialu,
    idUchwaly: props.idUchwaly,
    idopiniwroc: props.idopiniwroc,
    tab2: false,
    open: false,
    loadingdata: true,
    loadingdata2: false

  }

  this.getdata1();
  this.closeModal = this.closeModal.bind(this);
}

closeModal () {
  this.setState({ open: false })
}

componentDidMount(){
  ReactDOM.render(<NavBar token = {this.state.token} username = {this.state.username} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} kodoper = {this.state.kodoper} />, document.getElementById("header")); 
  
  if(this.props.idUchwaly !== undefined) {
    this.getdata2(this.props.idopiniwroc, this.props.idUchwaly)
  }
}

getdata1 = () => {
  axios
    .get(apiurl+"api/Opinie/Get1",{ params: { rok : this.props.rok },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ dataopinie1: response.data, loadingdata: false }),
    )
    .catch(error => {swal(error.response.data.Messege); this.setState({ loadingdata: false })} );
}

getdata2 = (idopini, iduchwaly) => {
  axios
    .get(apiurl+"api/Opinie/Get2",{ params: { rok : this.props.rok, idOpinii : idopini, idUchwaly : iduchwaly },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ dataopinie2: response.data , tab2 : true, loadingdata2: false }),
    )
    .catch(error => { swal(error.response.data.messege); this.setState({ loadingdata2: false })} );
}

postpozytywne = () => {
  axios.post(apiurl+"api/Opinie/Post3",
      {idOpinia: this.state.idopiniwroc, rok: this.props.rok, idUchwaly: this.state.idUchwaly, uwaga: "" },
      {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
      .then(res => {
        console.log('ok')
      })
  .catch(error => swal(error.response.data));
  }

  

render() {
  let { dataopinie1, dataopinie2, tab2, loadingdata, loadingdata2 } = this.state;
return (
<React.Fragment>
<div className="container-fluid">
<h1>Opinie</h1>

<hr />
<div className="col h-100">
<div className="fluid-row h-50 mb-3">
<div className="table-responsive m-1 card">
{loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <table class="table" width="100%">
    <thead>
      <tr>
        <th width="5%"><span>LP.</span></th>
        <th width="25%"><span>Dokument</span></th>
        <th width="30%"><span>Uwagi</span></th>
        <th width="20%"><span>Status</span></th>
        <th width="10%"><span>Wybierz</span></th>
        <th width="10%"><span>Zakończ opiniowanie</span></th>
      </tr>
    </thead>
    <tbody>
      {dataopinie1.map((data, index) => {
        const { id, lp, nazwaUchwaly, idOpinia, id_Uchwaly, status, uwagi } = data;
        let { indexwyb } = this.state;
        const idopini = idOpinia;
        const iduchwaly = id_Uchwaly;
        return (<>
        {index === indexwyb ? (<tr className="opiniawyb">
            <td>{lp}</td>
            <td>{nazwaUchwaly}</td>
            <td>{uwagi}</td>
            <td>{status}</td>
            <td><button type="button" class="btn btn-light " onClick={() => ( this.setState({ idUchwaly : iduchwaly, nazwaUchwaly : nazwaUchwaly , idopiniwroc : idopini, loadingdata2: true  }, this.getdata2(idopini, iduchwaly) )  )}>Wybierz</button></td>
            <td><button type="button" class="btn btn-light " onClick={() => ( this.setState({ open : true, idopinizakoncz : idopini, iduchwalyzakoncz: iduchwaly }) )} >Zakończ</button></td>
          </tr> ) : (<tr>
            <td>{lp}</td>
            <td>{nazwaUchwaly}</td>
            <td>{uwagi}</td>
            <td>{status}</td>
            <td><button type="button" class="btn btn-light " onClick={() => ( this.setState({ idUchwaly : iduchwaly, nazwaUchwaly : nazwaUchwaly , idopiniwroc : idopini, indexwyb : index, loadingdata2: true  }, this.getdata2(idopini, iduchwaly) )  )}>Wybierz</button></td>
            <td><button type="button" class="btn btn-light " onClick={() => ( this.setState({ open : true, idopinizakoncz : idopini, iduchwalyzakoncz: iduchwaly }) )} >Zakończ</button></td>
          </tr> )}
        </>);
      })}
    </tbody>
  </table>
  </div>
</div>
<hr />
{tab2 ? (<div className="fluid-row h-50 mt-3">
<button onClick={() => {
  swal({
    title: "Czy na pewno chcesz zmienic status wszystkich na Pozytywny?",
    text: "Wydziały z opinią negatywna lub zignorowaną zostaną pominięte.",
    buttons: {
    cancel: "Anuluj",
    catch: {
      text: "Zapisz",
      value: "willDelete",} 
    },
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      this.postpozytywne();
    } 
  });
}}
className="btn btn-light float-right mb-1" >Pozytywnie wszystkie</button>
<div className="table-responsive m-1 card">
{loadingdata2 ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <table class="table">
    <thead>
      <tr>
        <th width="30%"><span>Nazwa wydziału</span></th>
        <th width="30%"><span>Uwagi</span></th>
        <th width="15%"><span>Status</span></th>
        <th width="15%"><span>Wybierz</span></th>
      </tr>
    </thead>
    <tbody>
      {dataopinie2.length > 0 ? ( dataopinie2.map((data, index) => {
        const { idOpinia, id_Wydzialu, nazwaWydzialu, uwagi, status } = data;
        const { rok, idUchwaly, nazwaUchwaly, idopiniwroc, indexwyb } = this.state;
        return (
          <Wiersztabela2 rok={rok} index={index} idUchwaly={idUchwaly}  nazwaUchwaly={nazwaUchwaly}  idopiniwroc={idopiniwroc}  idOpinia={idOpinia}  id_Wydzialu={id_Wydzialu}  nazwaWydzialu={nazwaWydzialu}  uwagi={uwagi}  status={status} indexwyb={indexwyb} />
        );
      }) ) : ( <tr><td colSpan="4" className="text-center"><p>Brak danych</p></td></tr>)}
    </tbody>
  </table>
  </div>
</div>) : null }

</div>

</div>

<Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal}>
<div class="oknouwagi">
<a class="close point" onClick={this.closeModal}>
&times;
</a>
<Zak_opiniowanie rok={this.props.rok} idopini={this.state.idopinizakoncz} iduchwaly={this.state.iduchwalyzakoncz} />
</div>
</Popup>
</React.Fragment>
);
}
}


export class Wiersztabela2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rozwin: false,
    };
  }



  render() {
    let { rok, idUchwaly, nazwaUchwaly, idopiniwroc, idOpinia, id_Wydzialu, nazwaWydzialu, uwagi, status, index, indexwyb } = this.props;
    const uwagishort = uwagi.substring(0,50);
    return (
      <React.Fragment key={index}>
        <tr>
          <td>{nazwaWydzialu}</td>
          <td>{this.state.rozwin ? (<>{uwagi.length <=50 ? (<span>{uwagi}</span>) : (<span className="point" onClick={() => (this.setState({ rozwin : !this.state.rozwin}))}>{uwagi}</span>)}</>) : (<>{uwagi.length <=50 ? (<span>{uwagishort}</span>) : (<span className="point" onClick={() => (this.setState({ rozwin : !this.state.rozwin}))}>{uwagishort}...</span>)}</>)}</td>
          <td>{status}</td>
          <td><button class="btn btn-light " onClick={() => ( ReactDOM.render(<Opinie_wyb rok={rok} idopini={idOpinia} idUchwaly={idUchwaly} idWydzialu={id_Wydzialu} nazwaUchwaly={nazwaUchwaly} nazwaWydzialu={nazwaWydzialu} idopiniwroc={idopiniwroc} uwagi={uwagi} indexwyb={indexwyb} />, document.getElementById("root")) )}>Wybierz</button></td>
          </tr>
      </React.Fragment>
    );
  }
}